import client from "graphql/client";
import { loader } from "graphql.macro";
import { VIDEODESCRIPTIONS_REMOVE } from "../types";

const removeVideoDescriptionMutation = loader("../../graphql/mutations/videoDescriptionRemove.graphql");

export const removeVideoDescriptionAction = (videoDescriptionId) => async (dispatch) => {
    try {
        const response = await client.mutate({
            mutation: removeVideoDescriptionMutation,
            variables: { id: videoDescriptionId }
        });

        const removed = response?.data?.videoDescriptionRemove;
        if (removed) {
            dispatch({
                type: VIDEODESCRIPTIONS_REMOVE,
                videoDescriptionId
            });
            return true;
        }
    } catch (error) {
        console.error("Error deleting video description:", error);
    }

    return false;
};
